module.exports = __webpack_public_path__ + "static/img/30.00838dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/30.jpg
// module id = RqY5
// module chunks = 1